import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getAllPreInventory, type PreInventoryDto } from '../../api/bankFiles';
import { t } from '../../i18n/t';

// Read-only view of the tenant "מלאי קליטה" (PreInventory) staging table, for
// inspection/QA. All banks + dates in one grid — use the column filters to narrow.
const columnDefs: ColDef<PreInventoryDto>[] = [
  { field: 'bankId', headerName: t('preInventoryTable.columns.bankId'), width: 90, editable: false },
  { field: 'valueDate', headerName: t('preInventoryTable.columns.valueDate'), width: 120, editable: false },
  { field: 'acc', headerName: t('preInventoryTable.columns.acc'), width: 130, editable: false },
  { field: 'balanceCode', headerName: t('preInventoryTable.columns.balanceCode'), width: 100, editable: false },
  { field: 'assetId', headerName: t('preInventoryTable.columns.assetId'), width: 120, cellDataType: 'number', editable: false },
  { field: 'assetName', headerName: t('preInventoryTable.columns.assetName'), width: 200, editable: false },
  { field: 'qty', headerName: t('preInventoryTable.columns.qty'), width: 130, cellDataType: 'number', editable: false },
  { field: 'qty4Receive', headerName: t('preInventoryTable.columns.qty4Receive'), width: 130, cellDataType: 'number', editable: false },
  { field: 'crcyId', headerName: t('preInventoryTable.columns.crcyId'), width: 90, editable: false },
  { field: 'rate', headerName: t('preInventoryTable.columns.rate'), width: 100, cellDataType: 'number', editable: false },
  { field: 'noseType', headerName: t('preInventoryTable.columns.noseType'), width: 130, editable: false },
  { field: 'splitterCode', headerName: t('preInventoryTable.columns.splitterCode'), width: 110, editable: false },
];

export function PreInventoryTablePage() {
  return (
    <LopCrudPage<PreInventoryDto>
      resourceCode="bankFiles"
      titleKey="preInventoryTable.pageTitle"
      idField="preInventoryId"
      getRows={getAllPreInventory}
      saveBatch={async () => getAllPreInventory()}
      columnDefs={columnDefs}
      showAdd={false}
      showDelete={false}
    />
  );
}
